if (window.BSS_BCP_V2?.r4q?.logics?.length) {
    document.addEventListener("bcpR4q:addItemsSuccess", function (event) {
        document.body.dispatchEvent(new CustomEvent("bcpR4q:openForm", { bubbles: true, composed: true }));
    });

    if (BSS_BCP_V2.r4q.logics[0].rule.id === 825) {
        document.head.insertAdjacentHTML("beforeend", `
            <style> ${BSS_BCP_V2.cartPage.checkoutButtonSelectors.join(",")} { display: none; } </style>
        `);
    }
}

if(window.BSS_BCP_V2?.r4q?.logics?.length && window.BSS_BCP_V2?.r4q?.logics[0].rule.customerTags.includes("B2B")) {
    document.body.insertAdjacentHTML("beforeend",
        `<style >
             body > bcp-r4q-widget-main,
            .wt-header__panel__item.wt-header__panel__item--cart {
                display: none;
            }
        </style>` 
    )
   document.addEventListener("DOMContentLoaded",()=>{
        document.querySelectorAll(".wt-header__panel__item.wt-header__panel__item--cart").forEach(cartBtn => {
            cartBtn.insertAdjacentHTML('afterend',`
                 <bcp-r4q-widget-main style="position: unset;">
                    <div slot="icon" class="wt-header__panel__link wt-icon" style="display: flex; gap: 8px; cursor: pointer; margin-left: 11px; margin-right: 4px;" onclick="document.body.dispatchEvent(new CustomEvent('bcpR4q:openForm', { bubbles: true, composed: true }))">
                        <svg  class="svg-icon svg-icon--bag" aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_1" width="28" height="28" viewBox="0 0 28 28">                                   
                            <g id="Bag" transform="translate(0.105 0.256)">                
                                <rect id="Rectangle_2923" data-name="Rectangle 2923" width="28" height="28" transform="translate(-0.105 -0.256)" fill="none"></rect>                
                                <path id="shopping-bag" d="M20.578,23,18,5.787a.708.708,0,0,0-.7-.634H14.67V4.379a4.379,4.379,0,0,0-8.758,0v.775H3.029a.708.708,0,0,0-.7.634L0,23a.708.708,0,0,0,.7.782H19.874a.708.708,0,0,0,.7-.782ZM7.327,4.379a2.963,2.963,0,0,1,5.927,0v.775H7.327ZM1.493,22.366l2.173-15.8H5.912v.659a.708.708,0,0,0,1.416,0V6.569h5.927v.659a.708.708,0,0,0,1.416,0V6.569h1.988l2.431,15.8Zm0,0" transform="translate(3.647 1.967)"></path>            
                            </g>        
                        </svg> 
                    </div>
                 </bcp-r4q-widget-main>
            `)
        });
   })
}